import { render, staticRenderFns } from "./GenericFieldText.vue?vue&type=template&id=15657845&scoped=true&"
import script from "./GenericFieldText.vue?vue&type=script&lang=js&"
export * from "./GenericFieldText.vue?vue&type=script&lang=js&"
import style0 from "./GenericFieldText.vue?vue&type=style&index=0&id=15657845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15657845",
  null
  
)

export default component.exports